import React from 'react';
import './AccessDenied.css';

function AccessDenied() {
  const handleTryAgain = () => {
    window.location.href = '/api/auth.php?action=login&prompt=select_account';
  };

  return (
    <div className="access-denied-container">
      <div className="access-denied-card">
        <div className="denied-icon">🚫</div>
        <h1>Access Denied</h1>
        <p className="denied-message">
          Sorry, you don't have permission to access this dashboard. Please contact the administrator if you believe this is an error.
        </p>
        <button type="button" className="try-another-button" onClick={handleTryAgain}>
          Try Another Account
        </button>
      </div>
    </div>
  );
}

export default AccessDenied;
